export { default } from '../ai-stylist';
